import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./styles.css";

async function start() {
  const isLanding = window.location.pathname === "/";
  document.documentElement.classList.toggle("content-page", !isLanding);
  const Component = isLanding
    ? (await import("./App")).default
    : (await import("./guide/GuideApp")).default;
  const root = document.getElementById("root")!;
  const app = <StrictMode><Component /></StrictMode>;
  if (root.hasChildNodes()) hydrateRoot(root, app);
  else createRoot(root).render(app);
}

void start();
